import { useAppSelector } from "../../../../lib/redux/hooks";

export function ComparazionePreparazione() {
    const notificationState = useAppSelector(state => state.notification)
    const selectedNot = notificationState.notificationIdToUpdate;
    const comparisonState = useAppSelector(state => state.NotComparison)
    return (
        <div>
            {
                comparisonState.GetComparisonResponse && (
                    <>
                        <div className="displayFlex gap-3 mt-6">
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Attività presenti nella notifica {comparisonState.GetComparisonResponse.currentNotification}</span>

                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Attività</th>
                                                    <th>Filiera</th>
                                                    <th>Origine Mat. Prima</th>
                                                    <th>Opeeratore C/Terzi</th>
                                                    <th>Tipo Lavorazione</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    comparisonState.GetComparisonResponse.actualProcessingComparisons.map((actProcessing) =>
                                                        <tr>
                                                            <td>
                                                                {actProcessing.activity}
                                                            </td>
                                                            <td>
                                                                {actProcessing.productionChain}
                                                            </td>
                                                            <td>
                                                                {actProcessing.rawMaterialOrigin}
                                                            </td>
                                                            <td>{actProcessing.subcontracting}</td>
                                                            <td>{actProcessing.processingMethod}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Attività presenti nella notifica {comparisonState.GetComparisonResponse.previousNotification}</span>

                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Attività</th>
                                                    <th>Filiera</th>
                                                    <th>Origine Mat. Prima</th>
                                                    <th>Opeeratore C/Terzi</th>
                                                    <th>Tipo Lavorazione</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    comparisonState.GetComparisonResponse.previousProcessingComparisons.map((prevProcessing) =>
                                                        <tr>
                                                            <td>
                                                                {prevProcessing.activity}
                                                            </td>
                                                            <td>
                                                                {prevProcessing.productionChain}
                                                            </td>
                                                            <td>
                                                                {prevProcessing.rawMaterialOrigin}
                                                            </td>
                                                            <td>{prevProcessing.subcontracting}</td>
                                                            <td>{prevProcessing.processingMethod}</td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }

        </div>
    )
}